export const DisableButton = (disable: boolean) => {
  return disable ? 'cursor-not-allowed' : '';
}